module.exports = __webpack_public_path__ + "static/media/Rejected.7e6d7be4.png";